import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const UPDATE_DETAILS_FAIL = 'UPDATE_DETAILS_FAIL';

export const useOnUpdateDetailsFail = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback((detail: {
        formName: string;
        error: any;
    }) => {
        const event = new CustomEvent(UPDATE_DETAILS_FAIL, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('update_details:error', handleEvent);

        return () => publicEventsAPIService.off('update_details:error', handleEvent);
    }, [handleEvent]);
};
